import React from "react";
import { MdOutlineDirectionsBus } from "react-icons/md";
import "./PublicOfferIncludedTransfersCard.css";

/**
 * בלוק בולט להעברות כלולות בהצעת מחיר ללקוח (?offer=1).
 * @param {{ included: boolean, title: string, subtitle?: string } | null} vm
 */
export default function PublicOfferIncludedTransfersCard({ vm }) {
  if (!vm?.included) return null;

  return (
    <section
      className="public-offer-included-transfers"
      dir="rtl"
      aria-labelledby="public-offer-included-transfers-title"
    >
      <div className="public-offer-included-transfers__header">
        <MdOutlineDirectionsBus
          className="public-offer-included-transfers__header-icon"
          aria-hidden
        />
        <h3
          id="public-offer-included-transfers-title"
          className="public-offer-included-transfers__title"
        >
          {vm.title}
        </h3>
      </div>
      {vm.subtitle ? (
        <p className="public-offer-included-transfers__subtitle">{vm.subtitle}</p>
      ) : null}
    </section>
  );
}
